// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const Sidebar = ({ currentPage, setCurrentPage }) => {
//   const { t } = useTranslation();

//   const menuItems = [
//     { id: 'customers', label: t('nav.customers'), icon: '👥' },
//     { id: 'dashboard', label: t('nav.dashboard'), icon: '📊' },
//     { id: 'transactions', label: t('nav.transactions'), icon: '💳' },
//     { id: 'rewards', label: t('nav.rewards'), icon: '🎁' },
//     { id: 'sendsms', label: 'ارسال رسائل', icon: '✉️' }, 
//     // { id: 'settings', label: t('nav.settings'), icon: '⚙️' }
//   ];

//   return (
//     <aside className="sidebar">
//       <div className="sidebar-header">
//         <div className="logo">
//           <span className="logo-text">كوبرا<span className="logo-accent">بوينتس</span></span>
//         </div>
//       </div>
      
//       <nav className="sidebar-nav">
//         <ul>
//           {menuItems.map(item => (
//             <li key={item.id}>
//               <button 
//                 className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
//                 onClick={() => setCurrentPage(item.id)}
//               >
//                 <span className="nav-icon">{item.icon}</span>
//                 <span className="nav-label">{item.label}</span>
//               </button>
//             </li>
//           ))}
//         </ul>
//       </nav>
      
//       <div className="sidebar-footer">
//         <div className="version">{t('app.version')}</div>
//       </div>
//     </aside>
//   );
// };

// export default Sidebar;

import React from 'react';
import { useTranslation } from 'react-i18next';

const Sidebar = ({ currentPage, setCurrentPage, menuItems }) => {
  const { t } = useTranslation();

  // Use provided menuItems if available, otherwise use default items
  const items = menuItems || [
    { id: 'customers', label: t('nav.customers'), icon: '👥' },
    //{ id: 'dashboard', label: t('nav.dashboard'), icon: '📊' },
    { id: 'transactions', label: t('nav.transactions'), icon: '💳' },
    { id: 'rewards', label: t('nav.rewards'), icon: '🎁' },
    { id: 'sendsms', label: 'ارسال رسائل', icon: '✉️' }, 
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-text">كوبرا<span className="logo-accent">بوينتس</span></span>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <ul>
          {items.map(item => (
            <li key={item.id}>
              <button 
                className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
                onClick={() => setCurrentPage(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
      
      <div className="sidebar-footer">
        <div className="version">{t('app.version')}</div>
      </div>
    </aside>
  );
};

export default Sidebar;